import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 640) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <>
      <button 
        className="mobile-menu-button"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle menu"
      >
        <span className="mobile-menu-icon">☰</span>
      </button>
      {isMobileMenuOpen && (
        <div 
          className="mobile-menu-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}
      <aside className={`sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="sidebar-content">
        <div className="sidebar-section">
          <div 
            className="sidebar-section-header"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className={`sidebar-chevron ${isOpen ? 'open' : ''}`}>▶</span>
            <span className="sidebar-section-title">Pages</span>
          </div>
          <div className={`sidebar-section-content ${isOpen ? 'open' : ''}`}>
            <Link 
              to="/" 
              className={`sidebar-item ${isActive('/') ? 'active' : ''}`}
              onClick={() => window.innerWidth <= 640 && setIsMobileMenuOpen(false)}
            >
              <span className="sidebar-icon">👤</span>
              <span>About</span>
            </Link>
            <Link 
              to="/experience" 
              className={`sidebar-item ${isActive('/experience') ? 'active' : ''}`}
              onClick={() => window.innerWidth <= 640 && setIsMobileMenuOpen(false)}
            >
              <span className="sidebar-icon">💼</span>
              <span>Experience</span>
            </Link>
              <Link 
                to="/projects" 
                className={`sidebar-item ${isActive('/projects') ? 'active' : ''}`}
                onClick={() => window.innerWidth <= 640 && setIsMobileMenuOpen(false)}
              >
                <span className="sidebar-icon">🚀</span>
                <span>Projects</span>
              </Link>
          </div>
        </div>
      </div>
    </aside>
    </>
  );
};

export default Sidebar;

